/**
 * `FullAuditPage` — Full audit pivot page (/workspace/audit/full)
 *
 * Redirects to app-platform-admin full audit with context.
 */

// import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AdminAuditPivot } from '@/components/audit/AdminAuditPivot';
import { Stack, Text, Icon, tokens } from '@/design';
import type { AuditFilters } from '@/app/audit/auditDataClient';

export function FullAuditPage() {
  const [searchParams] = useSearchParams();

  // Build filters from URL params
  const filters: AuditFilters = {
    actor: searchParams.get('actor') || undefined,
    target: searchParams.get('target') || undefined,
    action: searchParams.get('action') || undefined,
    scope: searchParams.get('scope') || undefined,
    outcome: (searchParams.get('outcome') as AuditFilters['outcome']) || undefined,
    costClass: (searchParams.get('cost_class') as AuditFilters['costClass']) || undefined,
  };

  const timeStart = searchParams.get('time_start');
  const timeEnd = searchParams.get('time_end');
  if (timeStart && timeEnd) {
    filters.timeRange = { start: timeStart, end: timeEnd };
  }

  const confMin = searchParams.get('confidence_min');
  const confMax = searchParams.get('confidence_max');
  if (confMin && confMax) {
    filters.confidenceRange = { 
      min: parseFloat(confMin), 
      max: parseFloat(confMax) 
    };
  }

  return (
    <div style={{ 
      height: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: tokens.space[4],
    }}>
      <Stack direction="column" align="center" gap={4} style={{ textAlign: 'center' }}>
        <Icon name="policy" size={32} decorative />
        
        <Stack direction="column" gap={2}>
          <Text variant="body" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
            Opening Full Audit
          </Text>
          <Text variant="body" style={{ color: tokens.color.ink.secondary }}>
            You'll be redirected to the platform admin full audit with your current context.
          </Text>
        </Stack>

        <AdminAuditPivot filters={filters} />
        
        <Text variant="caption" style={{ color: tokens.color.ink.secondary }}>
          If the redirect doesn't work automatically, click the button above.
        </Text>
      </Stack>
    </div>
  );
}